export default __webpack_public_path__ + "static/media/american_forests_logo.0260971d.png";